import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import PhotoApiResponseModel from './photo.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'foto';
const DEFAULT_TIMEOUT = 50000;
const {handleApiError} = useHandleApiError();
// #endregion
// #region Public functions

async function searchPhoto(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new PhotoApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}
async function getPhotoById(photoId, throwError = true) {
  const searchParams = {
    globalSearch: '',
    filters: [
      {
        field: 'id',
        index: 1,
        matchMode: 'Equals',
        operator: 'And',
        value: photoId,
      },
    ],
    firxt: 0,
    rows: 0,
    pageIndex: 1,
    pageSize: 1,
    sortField: 'name',
    sortOrder: 'Asc',
  };
  const {data} = await searchPhoto(searchParams, throwError);
  if (!!data?.length) {
    return data[0];
  }
  return null;
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchPhoto,
  getPhotoById,
};
